import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import type { HelpSlug } from '@inventohub/shared';

export function HelpLink({
  slug,
  children = 'Help',
}: {
  slug: HelpSlug;
  children?: string;
}): JSX.Element {
  return (
    <Link to={`/help/${slug}`} className="help-inline" data-testid={`on-page-help-${slug}`}>
      {children}
    </Link>
  );
}
